import React, { useRef, useState } from "react";
import { motion } from "framer-motion";

/**
 * TiltCard — gentle 3D tilt on mouse move. Tasteful, max ~12deg.
 */
export const TiltCard = ({ children, className = "", max = 12, glare = true, ...rest }) => {
  const ref = useRef(null);
  const [transform, setTransform] = useState({ rx: 0, ry: 0 });
  const [glarePos, setGlarePos] = useState({ x: 50, y: 50, o: 0 });

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    setTransform({ rx: (0.5 - py) * max * 2, ry: (px - 0.5) * max * 2 });
    setGlarePos({ x: px * 100, y: py * 100, o: 0.18 });
  };

  const reset = () => {
    setTransform({ rx: 0, ry: 0 });
    setGlarePos((g) => ({ ...g, o: 0 }));
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      className={`sf-perspective relative ${className}`}
      style={{ transformStyle: "preserve-3d" }}
      animate={{ rotateX: transform.rx, rotateY: transform.ry }}
      transition={{ type: "spring", stiffness: 180, damping: 18 }}
      {...rest}
    >
      {children}
      {glare && (
        <div
          className="pointer-events-none absolute inset-0 rounded-[inherit]"
          style={{
            background: `radial-gradient(circle at ${glarePos.x}% ${glarePos.y}%, rgba(234,231,225,${glarePos.o}), transparent 55%)`,
            transition: "opacity 0.2s",
          }}
        />
      )}
    </motion.div>
  );
};

export default TiltCard;
